<template>
    <div class="fans" :class="{bg_height:isEmpty }">
        <ddHeader :title="titleName"></ddHeader>
        <div class="fans_item_contain" :class="{bg_empty:isEmpty ,bg_height:isEmpty}">
            <fans-item :name="item.nickname" :img-src="item.portrait_url" :jump-link="item.link_url" v-for="item in list" :key="item.id"></fans-item>
            <infinite-loading :on-infinite="onInfinite" ref="infiniteLoading">
    
                <div class="empty" slot="no-results">
                    <img src="../assets/images/failure.png" alt="">
                    <h2>{{emptyText}}</h2>
                </div>
            </infinite-loading>
        </div>
    </div>
</template>

<script>

var detectBack = {

    initialize: function () {
        //监听hashchange事件
        window.addEventListener('hashchange', function () {
            //为当前导航页附加一个tag
            this.history.replaceState('hasHash', '', '');

        }, false);

        window.addEventListener('popstate', function (e) {
            if (e.state) {
                //侦测是用户触发的后退操作, dosomething
                //这里刷新当前url
                this.location.reload();
            }
        }, false);
    }
}


import ddHeader from './header.vue'
import fansItem from './fansitem.vue'
import InfiniteLoading from './InfiniteLoading'
export default {
    name: 'myfollow',
    components: { ddHeader, fansItem, InfiniteLoading },
    data() {
        return {
            page: 1,
            list: [],
            isEmpty: false
        }
    },
    beforeCreate(){
        detectBack.initialize();
    },
    methods: {
        onInfinite() {
            this.$http({
                url: 'my.php',
                method: 'post',
                data: {
                    action: 'follow_list',
                    cust_id: '',
                    page: this.page++,
                    page_size: 15
                }
            }).then((res) => {
                var data = res.data;
                if (data.errorCode == 0 && data.data) {
                    var listData = data.data;
                    // this.page = 2;
                    // listData.length= 0;
                    if (this.page == 2) {
                        if (!listData.length) {
                            this.isEmpty = true;
                            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
                        }
                    }
                    if (data.data.length) {
                        this.isEmpty = false;
                        this.list = this.list.concat(data.data);
                        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
                    } else {
                        this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
                    }
                } else {
                    this.isEmpty = true;
                    this.errobj = {
                        type: 'pop',
                        errorMsg: data.errorMsg
                    }
                    this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
                }
            }).catch((e) => {
                this.errobj = {
                    type: 'pop',
                    errorMsg: '网络错误请稍后重试'
                }
            })
        }
    },
    computed: {
        titleName() {
            if (this.$store.state.isSelf) {
                return '我的关注'
            } else {
                return this.$store.state.TA + '的关注'
            }
        },
        emptyText(){
            if(this.$store.state.isSelf){
                return '您还没有关注！'
            }else{
                return this.$store.state.TA +'还没有关注!'
            }
        }
    }
}
</script>

<style lang="stylus">
    .bg_height
        height: 100%
    .fans
        overflow-y:auto
         background:#f5f5f5
        .fans_item_contain
            background:#fff
            margin-top:.25rem
        .bg_empty
            background:#f5f5f5
     
</style>



// WEBPACK FOOTER //
// myfollow.vue?53262ec4